import { Component, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { StorageService } from '../../common/services/storage.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-logout',
    imports: [RouterLink, MatButtonModule],
    templateUrl: './logout.component.html',
    styleUrl: './logout.component.scss'
})
export class LogoutComponent implements OnDestroy {
    private destroy$ = new Subject<void>();

    // isToggled
    isToggled = false;

    constructor(
        public themeService: CustomizerSettingsService,
        private storageService: StorageService,
    ) {
        this.themeService.isToggled$.pipe(takeUntil(this.destroy$)).subscribe(isToggled => {
            this.isToggled = isToggled;
        });

        storageService.logout();
    }


    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }

}